function isApplicationComponentConfig(value) {
    return (typeof value === "object" &&
        value !== null &&
        "componentId" in value &&
        typeof value.componentId === "string");
}
export function normalizeUiOverride(ui) {
    if (!ui?.components) {
        return null;
    }
    const components = Object.entries(ui.components).reduce((accumulator, [slot, component]) => {
        if (isApplicationComponentConfig(component)) {
            accumulator[slot] = component;
        }
        return accumulator;
    }, {});
    return Object.keys(components).length > 0 ? { components } : null;
}
class ApplicationUiStore {
    listeners = new Set();
    state = null;
    getComponent = (slot) => {
        return this.state?.components?.[slot] ?? null;
    };
    getState = () => {
        return this.state;
    };
    reset() {
        this.state = null;
        this.notify();
    }
    subscribe = (listener) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };
    update(ui) {
        if (this.state === ui) {
            return;
        }
        if (this.isShallowEqual(this.state, ui)) {
            return;
        }
        this.state = ui;
        this.notify();
    }
    isShallowEqual(previous, next) {
        if (previous === next)
            return true;
        if (previous === null || next === null)
            return false;
        const previousComponents = previous.components;
        const nextComponents = next.components;
        if (previousComponents === nextComponents)
            return true;
        if (!previousComponents || !nextComponents)
            return false;
        const previousKeys = Object.keys(previousComponents);
        const nextKeys = Object.keys(nextComponents);
        if (previousKeys.length !== nextKeys.length)
            return false;
        return previousKeys.every((key) => previousComponents[key] === nextComponents[key]);
    }
    notify() {
        this.listeners.forEach((listener) => listener());
    }
}
export const applicationUiStore = new ApplicationUiStore();
